import { gql } from '@apollo/client';

export const GET_ADVERTISING_ZONES = gql(/* GraphQL */ `
    query GetAdvertisingZones {
        getAdvertisingZones {
            id
            name
            isPriceSurveyModuleEnabled
            stores {
                id
                name
            }
        }
    }
`);

export const GET_ACCESSIBLE_ADVERTISING_ZONES = gql(/* GraphQL */ `
    query GetAccessibleAdvertisingZones {
        getAccessibleAdvertisingZones {
            id
            name
            isPriceSurveyModuleEnabled
            stores {
                id
                name
            }
        }
    }
`);

export const GET_ADVERTISING_ZONES_FILTER = gql(/* GraphQL */ `
    query GetAdvertisingZonesFilter {
        getAdvertisingZones {
            id
            name
        }
    }
`);

export default GET_ADVERTISING_ZONES;
